export default __webpack_public_path__ + "assets/MyriadPro-BoldCond.ed6934d6.svg";